import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function FadeIn({
  children,
  className = '',
  delay = 0
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    ease: [0.21, 0.47, 0.32, 0.98],
    delay
  }} className={className} data-id="element-14">
      {children}
    </motion.div>;
}